// extracted by mini-css-extract-plugin
module.exports = {"categories":"_3hJsT"};